var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"md"}},[_c('HeaderSection',{attrs:{"header":_vm.slice.primary.header,"teaser":_vm.slice.primary.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }